import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { useDashboard } from 'console/dashboards/z3k/provider';
import { SortablePanels } from 'console/shared/components/features/sortable-panels';
import { wrapping_element_props } from 'console/shared/components/tab/panel/utils';
import { useDeviceUISettings } from 'console/shared/contexts/device-ui-settings';
import { useDeviceConfig } from 'console/shared/contexts/device/config';
import * as S from '../styles';
export const DashboardHeatingDevice = memo(function DashboardHeatingDevice() {
    const { device_id } = useDeviceConfig();
    const { panels } = useDeviceUISettings();
    const { sorting_mode } = useDashboard();
    return (_jsx(S.DeviceContent, { initial: "open", animate: "open", exit: "close", variants: wrapping_element_props.variants, transition: wrapping_element_props.transition, sorting_mode: sorting_mode, children: _jsx(SortablePanels, { list: panels }) }, `dashboard-device-content-${device_id}`));
});
